import Vue from 'vue'
import App from './App'
import VueAwesomeSwiper from 'vue-awesome-swiper'
//引入路由
import VueRouter from 'vue-router';
//引入组件
import VueLazyload from 'vue-lazyload'
import 'swiper/css/swiper.css'
import Goods from './components/goods/Goods.vue'
import Ratings from './components/ratings/Ratings.vue'
import PinkupCode from './components/pinkupCode/PinkupCode.vue'
import Seller from './components/seller/Seller.vue'
import Feedback from './components/feedback/Feedback.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'


Vue.use(VueAxios,axios);
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
Vue.use(VueRouter);

Vue.use(VueLazyload,{
  preLoad: 1.3,
  error: './assets/error.png',
  loading: './assets/loading.png',
  attempt: 1
})


const routes=[
  {path:"/",redirect:"/goods"},
  {path:"/goods",component:Goods},
  {path:"/ratings",component:Ratings},
  {path:"/pinkup",component:PinkupCode},
  {path:"/seller",component:Seller},
  {path:"/feedback",component:Feedback},
  {path:"*",redirect:"/goods"}
]
const router = new VueRouter({
   mode: 'history',
   routes,
   linkActiveClass:"active"
  
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js